import React from 'react';
import * as MdIcons from 'react-icons/md';
import { incomeIcons, expenseIcons, getBackendIconName } from '../utils/iconHelper';
import './IconSelector.css';

function IconSelector({ selectedIcon, onSelectIcon, type }) {
  const icons = type === 'income' ? incomeIcons : expenseIcons;

  return (
    <div className="icon-selector">
      <label className="icon-selector-label">Ícone</label>
      <div className="icon-selector-grid">
        {icons.map((iconName) => {
          const IconComponent = MdIcons[iconName];
          const backendName = getBackendIconName(iconName);
          const isSelected = selectedIcon === backendName;

          return (
            <button
              key={iconName}
              type="button"
              className={`icon-button ${isSelected ? 'selected' : ''}`}
              onClick={() => onSelectIcon(backendName)}
              title={backendName.replace(/_/g, ' ')}
            >
              <IconComponent size={24} />
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default IconSelector;
